import s from "./style.module.css";
export interface Input extends Marko.HTML.Section {
    as?: "section" | "div";
    paddingBlock?: (PaddingSize | null)[];
    paddingInline?: boolean;
    background?: BackgroundColor[];
    fullScreen?: boolean;
}
export type PaddingSize = "xs" | "sm" | "md" | "lg" | "xl" | "none";
export type BackgroundColor = "primary" | "secondary" | null;

<const/{
    as: tag = "section",
    content,
    paddingBlock,
    paddingInline = true,
    class: className,
    background = [],
    fullScreen = false,
    ...rest
}=input>

<${tag as "section"}
    ...rest
    class=[s.section, className]
    data-pad-inline=`${paddingInline}`
    data-pb-start=(paddingBlock?.[0] ?? "lg")
    data-pb-end=(paddingBlock?.[1] ?? "lg")
    data-bg-light=background[0]
    data-bg-dark=background[1]
    data-full-screen=`${fullScreen}`>
    <${content}/>
</>
